module.exports = __webpack_public_path__ + "static/media/Clock.3b4cb8c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Clock.svg
// module id = 436
// module chunks = 0